export const PRODUCT_LINES = {
    ADOPT_BASE: 'adopt',
    ADOPT: 'adoptEndUser',
    ADOPT_RESELLER: 'adoptReseller',
    AGENT_ANALYTICS: 'agentAnalytics',
    ANALYTICS: 'analytics',
    COMMAND_CENTER: 'commandCenter',
    CORE: 'core',
    FEEDBACK: 'feedback',
    GUIDES: 'guides',
    IDEAS: 'ideas',
    LICENCE_UTILIZATION: 'licenseUtilizationEnabled',
    NPS: 'nps',
    PREDICT: 'predict',
    ONE_UI_ENGINEERING: 'oneUIEngineeringUse',
    ORCHESTRATE: 'orchestrate',
    ROADMAPS: 'roadmaps',
    SESSION_REPLAY: 'sessionReplay',
    VOC: 'voc',
};

export const ANALYTICS_PRODUCT_LINE_WIDGETS = [
    'timeToFirstUse',
    'retentionByUsage',
    'customReportChart',
    'funnelReportChart',
    'pathReportChart',
    'retentionReportChart',
    'stickinessMetric',
    'productEngagementScore',
    'pesTrending',
    'licenseUtilization',
];
